import { MINIMAL_BUTTON_INTERNAL_PADDING } from './constants';
function getGetterSum({ count, getter }) {
    if (count === 1) {
        return MINIMAL_BUTTON_INTERNAL_PADDING; // The sum internal button paddings
    }
    return MINIMAL_BUTTON_INTERNAL_PADDING * count + getter * (count - 1);
}
export function getButtonsParameters({ holderRef, childElements, getter, }) {
    const filteredChild = childElements.filter((itemCurrent) => itemCurrent?.current) || [];
    const count = filteredChild.length;
    if (holderRef?.current) {
        // Case if array with refs has single child
        if (count === 1 && filteredChild[0]?.current) {
            const buttonWidth = filteredChild[0]?.current?.parentElement?.offsetWidth || 0;
            const contentButtonWidth = filteredChild[0]?.current?.offsetWidth || 0;
            const commonDiff = buttonWidth - contentButtonWidth;
            const isArrangedByLineResult = commonDiff >
                getGetterSum({
                    count,
                    getter,
                });
            return {
                isArrangedByLineResult,
                count,
            };
        }
        // Default case
        if (count > 1 && childElements[0]?.current && childElements[1]?.current) {
            const commonClientWidth = holderRef?.current?.clientWidth
                ? holderRef?.current?.clientWidth
                : 0;
            let sumWidthElements = 0;
            childElements?.forEach((item) => {
                const itemButtonContentWidth = item.current?.offsetWidth || 0;
                sumWidthElements += itemButtonContentWidth;
            });
            const commonDiff = commonClientWidth - sumWidthElements;
            const isArrangedByLineResult = commonDiff >
                getGetterSum({
                    count,
                    getter,
                });
            return {
                isArrangedByLineResult,
                count,
            };
        }
    }
    return {
        isArrangedByLineResult: null,
        count: 0,
    };
}
